import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list2",
  "use": "list2-usage",
  "viewBox": "0 0 16 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" viewBox=\"0 0 16 20\" id=\"list2\"><rect width=\"14.4\" height=\"18.4\" x=\".8\" y=\".8\" rx=\"1.2\" /><path stroke-linecap=\"round\" d=\"M3.5 4h9m-9 4h9m-9 4h9m-9 4h9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol